import { Injectable } from '@angular/core';
import { ConfigService } from "./config.service";
import { HttpServiceService } from "./http-service.service";
@Injectable({
  providedIn: 'root'
})
export class BranchService {

  constructor(private config: ConfigService,public http: HttpServiceService) { }



  public BranchListURL: string = "Branch/GetBranchListV1";
  public ContentURL: string = "Content/GetContactUs";
  public LinksURL: string = "Content/GetQuickLinks";


  
  GetBranchListV1() {
    return new Promise((resolve, reject) => {
      this.http
        .postToOpenApi(
          this.config.server + this.BranchListURL, {}, )
        .subscribe(
          (res: any) => {
            if (res.response) {
              if (res.response.code) {
                if (res.response.code == 1) {
                }
              }
            }
            resolve(res);
          },
          (Error) => {
            resolve(Error);

          }
        );
    });
  }


  Content() {
    return new Promise((resolve, reject) => {
      this.http.postToOpenApi( this.config.server + this.ContentURL, {} ).subscribe(
          (res: any) => {
            if (res.response) {


              if (res.response.code) {
                if (res.response.code == 1) {
                }
              }
            }
            resolve(res);
          },
          (Error) => {
            resolve(Error);

          }
        );
    });
  }


  GetQuickLinks() {
    return new Promise((resolve, reject) => {
      this.http.postToOpenApi( this.config.server + this.LinksURL, {} ).subscribe(
          (res: any) => {
            if (res.response) {


              if (res.response.code) {
                if (res.response.code == 1) {
                }
              }
            }
            resolve(res);
          },
          (Error) => {
            resolve(Error);

          }
        );
    });
  }


  
}
